/**
 * DataTableFooter class
 *
 * @package    DataTable
 * @author     Maxim Lukianenko <mlukianenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell/TableCell';
import { isEmpty } from 'Utils';

import { DataTableMetadataType } from 'Types';

export default class DataTableFooter extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        metadata: DataTableMetadataType,
        onChangePage: PropTypes.func.isRequired,
        onChangeRowsPerPage: PropTypes.func.isRequired,
        colSpan: PropTypes.number,
        footerMessage: PropTypes.any,
    };

    /**
     * DefaultProps
     */
    static defaultProps = {
        colSpan: 3,
    };

    rowsPerPageOptions = [10, 20, 50, 100];

    onChangePage = (event, page) => {
        const { onChangePage } = this.props;
        onChangePage(page + 1);
    };

    onChangeRowsPerPage = event => {
        const { onChangeRowsPerPage } = this.props;
        onChangeRowsPerPage(event.target.value);
    };

    render() {
        const { metadata, colSpan, footerMessage } = this.props;

        return (
            <TableFooter>
                <TableRow>
                    {!isEmpty(metadata) && (
                        <TablePagination
                            colSpan={colSpan}
                            count={metadata.total}
                            rowsPerPage={metadata.perPage}
                            page={metadata.page - 1}
                            rowsPerPageOptions={this.rowsPerPageOptions}
                            onChangePage={this.onChangePage}
                            onChangeRowsPerPage={this.onChangeRowsPerPage}
                            SelectProps={{className: 'botTableRows'}}
                            classes={{menuItem: 'pagination-menu-item'}}
                        />
                    )}
                    {isEmpty(metadata) && footerMessage &&
                        <TableCell colSpan={colSpan}>
                            { footerMessage }
                        </TableCell>
                    }
                </TableRow>
            </TableFooter>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableFooter.jsx